// extracted by mini-css-extract-plugin
export default {"Share":"Sharing_Share__nyLbQ"};